import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatRadioButton } from '@angular/material/radio';
import { AdvancedSearchFormData, Filters } from '../../models/common';



@Component({
  selector: 'antera-lib-kanban-search-advanced-form',
  templateUrl: './kanban-search-advanced-form.component.html',
  styleUrls: ['./kanban-search-advanced-form.component.scss'],
})
export class KanbanSearchAdvancedFormComponent implements OnInit {
  @Input() advancedSearchFormData: AdvancedSearchFormData = {
    title: '',
    description: '',
    filters: [{value:'', name: '', hint: ''}],
  };
  @Input() page: string = '';
  @Input() public mappingFields: any[] =  [];
  @Input() public reSynceNeeded = false;
  public radioValues: string[] = [];
  @Output() public inputValueChange: EventEmitter<any> = new EventEmitter();
  @Output() public ontToggleResyncQBO: EventEmitter<any> = new EventEmitter();
  @Input() public qboActive = false;

  constructor() {
    //console.log("advancedSearchFormData",this.advancedSearchFormData);
  }

  ngOnInit(): void {
    this.radioValues = new Array(this.advancedSearchFormData.filters.length);
  }

  ngOnChanges(){
    this.radioValues = new Array(this.advancedSearchFormData.filters.length);
  }

  public onRadioBtnChange(event: MatRadioButton, filter: Filters){
    const foundFilter = this.advancedSearchFormData.filters.find((filterVal: Filters) => filterVal.id === filter.id) || null;

    if(foundFilter){
      foundFilter.value = event.value;
    }
  }


  change(event: any,filter: any) {
    console.log("change event",event);
    console.log("change filter",filter);
    let data = {
      event,
      filter
    }
    this.inputValueChange.emit(data);
  }

  public toggleResyncQBO(event: any) {
    this.ontToggleResyncQBO.emit(event);
  }
}
